import { Tooltip } from "antd";

const HeaderIconBox = ({ 
    tooltip, 
    children, 
    badgeCount = 0,
    marginRight = 'calc(var(--sp-md2)*1.132075)',
    overlayInnerStyle = { fontSize: 'calc(var(--fs-xs)*1.2)', padding: 'var(--sp-sm) var(--sp-md2)' }
}) => {
    return (
        <Tooltip
            title={tooltip} 
            overlayInnerStyle={overlayInnerStyle}
            overlayClassName="premium-header-tooltip"
        >
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: 'var(--fs-hero)',
                    height: 'var(--fs-hero)',
                    borderRadius: 'calc(var(--sp-md2)*1.132075)',
                    background: 'rgba(255, 255, 255, 0.08)',
                    border: '1px solid rgba(255, 255, 255, 0.12)',
                    backdropFilter: 'blur(14px)',
                    boxShadow: `
                    inset 0 1px 0 rgba(255,255,255,0.05),
                    0 6px 18px rgba(0,0,0,0.16)
                    `,
                    cursor: 'pointer',
                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                    marginRight: marginRight,
                    position: 'relative'
                }}
                onMouseEnter={(e) => {
                    e.currentTarget.style.background = 'rgba(255,255,255,0.12)';
                    e.currentTarget.style.borderColor = 'rgba(255,255,255,0.2)';
                    e.currentTarget.style.transform = 'translateY(calc(var(--fs-xxs)*-0.18867925))';
                    e.currentTarget.style.boxShadow = '0 4px 12px rgba(88, 115, 235, 0.2)';
                }}
                onMouseLeave={(e) => {
                    e.currentTarget.style.background = 'rgba(255, 255, 255, 0.08)';
                    e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.12)';
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = 'none';
                }}
            >
                <div style={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {children}
                    
                    {/* Badge - Renders only if badgeCount > 0 */}
                    {badgeCount > 0 && (
                        <div
                            style={{
                                position: 'absolute',
                                top: 'calc(var(--sp-xxs)*-2)',
                                right: 'calc(var(--sp-xxs)*-2)',
                                background: 'linear-gradient(135deg, #c084fc 0%, #8b5cf6 100%)',
                                color: 'white',
                                fontSize: 'calc(var(--fs-xs)*1.1320753)',
                                fontWeight: '700',
                                padding: 'calc(var(--sp-xxs)*0.471698) calc(var(--sp-xxs)*1.4150943)',
                                borderRadius: '999px',
                                minWidth: 'var(--fs-xl)',
                                textAlign: 'center',
                                boxShadow: '0 2px 8px rgba(167, 139, 250, 0.4)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                height: 'var(--fs-xl)',
                                lineHeight: '1'
                            }}
                        >
                            {badgeCount}
                        </div>
                    )}
                </div>
            </div>
        </Tooltip>
    );
};

export default HeaderIconBox;